export default { sha: 'b896d72d3cbf399762cd892a69f538e3530c7d12', buildNumber: 'undefined' }
